import { useEffect, useState } from 'react'
import { throttle } from 'throttle-debounce'
import { Button } from '../Button'
import { Icon } from '../Icon'
import { tm } from '../tm'

interface ScrollTopProps {
  threshold?: number
  container?: HTMLElement
  className?: string
}

export function ScrollTop({
  threshold = 1000,
  container = undefined,
  className = '',
}: ScrollTopProps) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    function toggleVisible() {
      const scrollY = container ? container.scrollTop : window.scrollY
      const isVisible = scrollY > threshold
      setVisible(isVisible)
      if (isVisible) {
        const timeoutId = setTimeout(() => {
          setVisible(scrollY > threshold)
          clearTimeout(timeoutId)
        }, 300)
      }
    }

    const throttledToggleVisible = throttle(400, toggleVisible)

    ;(container || window).addEventListener('scroll', throttledToggleVisible)

    return () => {
      ;(container || window).removeEventListener(
        'scroll',
        throttledToggleVisible,
      )
    }
  }, [threshold, container])

  return (
    <Button
      ariaLabel="Scroll to top"
      variant="naked"
      onClick={() => {
        ;(container || window).scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }}
      className={tm(
        'pointer-events-none fixed bottom-14 left-1/2 z-10 h-16 w-16 -translate-x-1/2 items-center justify-center rounded-lg border border-dark-purple bg-light-purple opacity-0 shadow-lg',
        className,
        visible && 'opacity-1 pointer-events-auto',
      )}
    >
      <Icon icon="arrow-upward" size="normal" />
    </Button>
  )
}
